import { render, staticRenderFns } from "./TableSubscription.vue?vue&type=template&id=2877ed56"
import script from "./TableSubscription.vue?vue&type=script&lang=js"
export * from "./TableSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports